import { httpCreate } from './http.js';

const http = httpCreate('/srv/activityGather');

export const activityGather = {
	/*********** 企业版合并 **********/
	/** 获取合集列表
	 *
	 * @param { Number } params.photoLive
	 * @param { Number } params.pageNum
	 * @param { Number } params.pageSize
	 */
	getGatherList(params) {
		return http.get('/gatherList', { params });
	},
	/*******************************/
	sortChildGather(gatherId, ids) {
		return http.post(`/sortChildGather/${gatherId}`, ids);
	},
	delChild(childGatherId) {
		return http.delete(`/delChild/${childGatherId}`);
	},
	getChildList(gatherId) {
		return http.get(`/getActivity/${gatherId}`);
	},
	updateChild(childGatherId, params) {
		return http.post(`/updateChild/${childGatherId}`, params);
	},
	sortActivity(childGatherId, ids) {
		return http.post(`/sortActivity/${childGatherId}`, ids);
	},
	saveChild(gatherId, params) {
		return http.post(`/saveChild/${gatherId}`, params);
	},
	// getChildList(gatherId) {
	// 	return http.get(`/getChildList/${gatherId}`);
	// },
	activityGatherList(id, params) {
		return http.get(`/${id}`, { params });
	},
	createActivityGather(data) {
		return http.post('', data);
	},
	update(id, data) {
		return http.post(`/update/${id}`, data);
	},
	activityGatherDelete(id, params) {
		return http.delete(`/${id}`, { params });
	},
	getById(id) {
		return http.get(`/getById/${id}`);
	},
	delActivity(albumId, activiteId) {
		return http.delete(`/delActivity/${albumId}/${activiteId}`);
	},
	delCurrentActivity(albumId, activiteId, childGatherId) {
		return http.delete(`/delActivity/${albumId}/${childGatherId}/${activiteId}`);
	},
	addActivity(gatherId, childGatherId, ids) {
		return http.post(`/addActivity/${gatherId}/${childGatherId}`, ids);
	},
	// addActivity(id, data) {
	// 	return http.post(`/addActivity/${id}`, data);
	// },
	getGatherAllList(params) {
		return http.get('/getGatherList', { params });
	},
	saveShare(id, data) {
		return http.post(`/saveShare/${id}`, data);
	},
	saveScreen(gatherId, data) {
		return http.post(`/screen/${gatherId}`, data);
	},
	getBase(gatherId) {
		return http.get(`/getBase/${gatherId}`);
	},
	topActivity(gatherId, activityId, isTop) {
		return http.put(`/topActivity/${gatherId}/${activityId}/${isTop}`);
	},
	gatherRelationBanner(gatherRelationId, body) {
		return http.put(`/gatherRelation/banner/${gatherRelationId}`, body);
	},
	getEEGatherList(params) {
		return http.get('', { params });
	},
};
